import React from 'react';
import './Logo.css';

const Logo = ({ size = 50, showText = true }) => {
    return (
        <div className="logo-container">
            <svg 
                width={size} 
                height={size} 
                viewBox="0 0 100 100" 
                className="logo-svg"
            >
                {/* Outer circle with gradient */}
                <defs>
                    <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style={{stopColor: '#0e2d1d', stopOpacity: 1}} />
                        <stop offset="100%" style={{stopColor: '#25D366', stopOpacity: 1}} />
                    </linearGradient>
                    <filter id="glow">
                        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
                        <feMerge>
                            <feMergeNode in="coloredBlur"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                </defs>
                
                {/* Main circle */}
                <circle 
                    cx="50" 
                    cy="50" 
                    r="45" 
                    fill="none" 
                    stroke="url(#logoGradient)" 
                    strokeWidth="3"
                    className="logo-circle"
                />
                
                {/* Inner decorative circles */}
                <circle cx="50" cy="50" r="35" fill="none" stroke="url(#logoGradient)" strokeWidth="1" opacity="0.5"/>
                
                {/* Scissors/Barber blade shape */}
                <g transform="translate(50, 50)" filter="url(#glow)">
                    {/* Left blade */}
                    <path 
                        d="M -20,-10 L -15,10 L -10,8 L -15,-8 Z" 
                        fill="url(#logoGradient)"
                        className="blade-left"
                    />
                    {/* Right blade */}
                    <path 
                        d="M 20,-10 L 15,10 L 10,8 L 15,-8 Z" 
                        fill="url(#logoGradient)"
                        className="blade-right"
                    />
                    {/* Center pivot */}
                    <circle cx="0" cy="0" r="4" fill="#25D366" className="pivot"/>
                    
                    {/* Decorative elements */}
                    <line x1="-8" y1="-15" x2="-8" y2="-20" stroke="#25D366" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="8" y1="-15" x2="8" y2="-20" stroke="#25D366" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="0" y1="-18" x2="0" y2="-23" stroke="#0e2d1d" strokeWidth="2" strokeLinecap="round"/>
                </g>
            </svg>
            {showText && <span className="logo-text">مركز بالي</span>}
        </div>
    );
};

export default Logo;
